/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var old_models = [
    mp.marketing.trends.utils.IPHONE_11_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_11_PRO,
    mp.marketing.trends.utils.IPHONE_11,
    mp.marketing.trends.utils.IPHONE_SE_2ND_GEN,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];
  var release_models = [
    mp.marketing.trends.utils.IPHONE_12,
    mp.marketing.trends.utils.IPHONE_12_PRO,
    mp.marketing.trends.utils.IPHONE_12_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_12_MINI,
  ];
  var IPhone12 = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models.concat(old_models.slice(0, 3));
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    getDownloadName() {
      return ns.IPhone12.nice_name;
    },
  });

  Object.assign(IPhone12, {
    slug: `iphone_12`,
    nice_name: `iPhone 12 adoption`,
    description: `How quickly will people start using the new iPhone 12 models?`,
  });
  ns.IPhone12 = IPhone12;
});

}.call(window));